import React from 'react';

type FourOhFourProps = {
  color?: string;
};

export const FourOhFour = ({ color }: FourOhFourProps) => {
  return (
    <svg
      width="282"
      height="100"
      viewBox="0 0 282 100"
      fill="none"
      data-cy="sad-wolf"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_868_14806)">
        <path
          d="M140.697 0C112.9 0 90.3643 22.5356 90.3643 50.3329C90.3643 60.1384 93.1714 69.291 98.0284 77.0336C98.8902 76.3416 99.8302 75.8454 100.823 75.4537C102.807 74.6834 104.961 74.3439 106.985 73.7825C109.179 73.1688 111.229 71.589 112.012 69.7872C109.27 69.3955 106.463 69.3302 103.773 67.9723C104.191 67.6459 104.518 67.3978 104.818 67.1236C108.16 64.1859 111.503 61.2613 114.806 58.2713C115.381 57.7491 115.811 56.9787 116.099 56.2345C117.626 52.2653 119.063 48.27 120.603 44.3139C120.877 43.6219 121.36 42.9038 121.961 42.4729C124.285 40.8278 126.688 39.3132 129.038 37.7073C129.469 37.42 129.899 36.9631 130.069 36.493C131.858 31.4532 134.469 26.8834 137.668 22.6139C139.418 20.2899 141.011 17.8483 142.617 15.4198C143.126 14.6625 143.674 14.6625 144.366 14.9889C147.722 16.6079 150.411 21.7783 149.798 25.4472C149.484 27.2882 149.145 29.1161 148.831 30.957C148.779 31.2573 148.779 31.5707 148.727 32.1321C151.208 31.1007 152.566 29.0769 154.38 27.4448C155.804 30.1084 156.678 32.6805 155.373 35.6835C154.772 37.0806 154.446 38.7257 154.472 40.2402C154.55 44.1964 154.89 48.1394 155.138 52.0825C155.138 52.1739 155.125 52.2653 155.112 52.5134C154.302 51.8083 153.571 51.1686 152.84 50.5418C152.761 50.5941 152.67 50.6332 152.67 50.6724C152.539 56.117 152.774 61.5354 153.95 66.8756C154.302 68.4815 155.007 70.0091 155.569 71.6412C154.85 71.6412 153.976 71.6412 152.983 71.6412C153.062 80.1018 152.592 88.3536 150.085 96.5139C149.732 97.6759 149.328 98.838 148.884 100C172.777 96.083 191.004 75.3362 191.004 50.3329C191.017 22.5356 168.481 0 140.697 0Z"
          fill={color ?? 'white'}
        />
        <path
          d="M0 66.9278V65.7266L32.798 0H33.3333L55.7383 1.99765L56.6654 3.9953L23.0709 62.7889V63.3242H47.9958L52.9312 37.6028H69.056V63.3242H83.8491V80.5197H69.056V99.9869H46.7946V80.5197H2.53297L0 66.9278Z"
          fill={color ?? 'white'}
        />
        <path
          d="M197.532 66.9278V65.7266L230.33 0H230.866L253.271 1.99765L254.198 3.9953L220.59 62.8019V63.3372H245.515L250.45 37.6028H266.575V63.3372H281.368V80.5327H266.575V100H244.314V80.5327H200.052L197.532 66.9278Z"
          fill={color ?? 'white'}
        />
      </g>
      <defs>
        <clipPath id="clip0_868_14806">
          <rect width="281.394" height="100" fill={color ?? 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};
